export default __webpack_public_path__ + "static/media/clear.328b0931.svg";